/** @jsx jsx */
import { jsx } from '@emotion/core';

import { styled } from '@material-ui/core/styles';
import {
  Typography,
  Card,
  CardContent,
  Box,
  Grid,
  TextField,
} from '@material-ui/core';
import PasswordField from '../../password-text-field';
import theme from '../../../themes/theme';
import routes from '../../../routes';
import Link from '../../text-link';
import { useInvoicePaymentForgotPassword } from '../../../hooks/invoice-payment-portal/useInvoicePaymentForgotPassword';
import PGEButton from '../../buttons';
import { useLocation } from '@reach/router';

const PREFIX = 'InvoicePaymentLoginForm';

const classes = {
  card: `${PREFIX}-card`,
  cardContent: `${PREFIX}-cardContent`,
  cardActions: `${PREFIX}-cardActions`,
  hr: `${PREFIX}-hr`,
  submit: `${PREFIX}-submit`,
  paidMessageBox: `${PREFIX}-paidMessageBox`,
};

const Root = styled('div')(() => ({
  [`& .${classes.card}`]: {
    padding: '6em 6em',
    marginTop: '2em',
    [theme.breakpoints.down('sm')]: {
      padding: '4em 2em',
    },
  },
  [`& .${classes.cardContent}`]: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
  },
}));

const InvoicePaymentVerifyAndResetPassword = () => {
  const {verifyPasswordForm,content,handleResetSubmit} = useInvoicePaymentForgotPassword();
  const { state } = useLocation() as { state?: { email?: string } };
  const email = state?.email;
  return (
    <Root>
      <Card className={classes.card}>
        <CardContent className={classes.cardContent}>
          <Typography variant={'h1'} css={{ marginBottom: theme.spacing(1) }}>
            {content.get('VERIFY_AND_RESET_PASSWORD')}
          </Typography>
          
          <Typography>
            {content.get('VERIFY_AND_RESET_PASSWORD_DESC')! + `${email}`}
          </Typography>
          <form
            noValidate
            onSubmit={
              email
                ? handleResetSubmit(email)
                : (e) => {
                    console.error('VerifyAndResetPassword: email is missing');
                    e.preventDefault();
                  }
            }
          >
          <Grid
              container
              justify="flex-end"
              alignContent="center"
              spacing={2}
              alignItems="center"
            >
             <Grid item xs={12}>
                <PasswordField
                  name="newPassword"
                  label={content.get('ENTER_A_PASSWORD')}
                  variant="outlined"
                  autoComplete={'newPassword'}
                  {...verifyPasswordForm.props('newPassword')}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  name={'otp'}
                  label={content.get('ENTER_A_OTP')}
                  variant="outlined"
                  style={{width:'100%'}}
                  inputProps={{ minLength: 1, maxLength: 6 }}
                  {...verifyPasswordForm.props('otp')}
                />
              </Grid>
            
            </Grid>
            <Box
              display="flex"
              justifyContent="space-between"
              css={{ marginTop: theme.spacing(3) }}
            >
              <Link
                plain
                to={routes.INVOICE_PAYMENT_PORTAL_SIGN_IN}
                variant={'body2'}
              >
                {content.get('BACK_TO_SIGNIN')}
              </Link>
              <PGEButton
                      data-testid="forgot-password-button"
                      type={'submit'}
                      variant={'contained'}
                      color={'primary'}
                      disabled={!email}
                      >
                      {content.get('SUBMIT')}
                    </PGEButton>
            </Box>
          </form>
        </CardContent>
      </Card>
    </Root>
  );
};

export default InvoicePaymentVerifyAndResetPassword;
